import React, { useContext, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { CartContext } from "./CartContext";
import "../css/paysuccess.css";

const PaymentResult = () => {
  const [searchParams] = useSearchParams();
  const { clearCart } = useContext(CartContext);
  const isSuccess = searchParams.get("state") === "success";

  useEffect(() => {
    if (isSuccess) clearCart();
  }, [clearCart, isSuccess]);

  return (
    <main className="payment-result">
      <section className={`payment-result__card ${isSuccess ? "is-success" : "is-cancel"}`}>
        <div className="payment-result__icon" aria-hidden="true">
          <FontAwesomeIcon icon={isSuccess ? faCheck : faXmark} />
        </div>
        <h1>{isSuccess ? "Payment successful" : "Payment cancelled"}</h1>
        <p>
          {isSuccess
            ? "Thank you. Your order has been received and is now being processed."
            : "Your payment was not completed. Your cart has been kept so you can try again."}
        </p>
        <Link className="payment-result__action" to={isSuccess ? "/shop" : "/checkout"}>
          {isSuccess ? "Continue shopping" : "Return to checkout"}
        </Link>
      </section>
    </main>
  );
};

export default PaymentResult;
